module.exports = __webpack_public_path__ + "static/media/booking.c9ebf5b6.png";